import { defineComponent as _defineComponent } from 'vue'
import ImageGallery from '../components/ImageGallery.vue'
import { usePhotoStore } from "@/stores/photostore";


export default /*#__PURE__*/_defineComponent({
  __name: 'PhotoView',
  setup(__props) {


const photoStore = usePhotoStore();

function hideOverlay() {
  photoStore.showBigPhoto = false;
}

function swipe(direction: string) {
  switch (direction) {
    case "Up":
      photoStore.showBigPhoto = false;
      break;
    case "Down":
      photoStore.showBigPhoto = false;
      break;
    case "Left":
      photoStore.goNext();
      break;
    case "Right":
      photoStore.goBack();
      break;
  }
}


return { __sfc: true,photoStore, hideOverlay, swipe, ImageGallery }
}

})